

import './App.css';
import 'bootstrap/dist/css/bootstrap.css';

//import ReactAnimatedWeather from 'react-animated-weather';
import Weather from "./Weather.js";

function App() {
  return (
    <div className="container">
      <div className="App">
      <Weather mainCity="New York"/>
      
      <footer>
      Codded by<span> </span>
      <a href="https://github.com/DuxSv" target="_blank" rel="noreferrer" title="DuxSv github">
        DuxSv
      </a><span> </span>
      and hosting by <span> </span>
      <a
        href="https://my-weather-react-app-duxsv.netlify.app/"
        target="_blank"
        title="netlify_link"
        rel="noreferrer"
      >
        Netlify
      </a>
    </footer>
    </div>
    </div>
  );
}

export default App;
